import {faPlus} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button} from 'antd';

import {appRoute} from '../../../../../app-route';
import {NavigationLink} from '../../../../../layout/navigation-link/navigation-link';

export function AddReviewButton(): JSX.Element {
    return (
        <NavigationLink isTargetBlank to={appRoute.reviewsManagementCreateReview.path}>
            <Button icon={<FontAwesomeIcon icon={faPlus} />} />
        </NavigationLink>
    );
}
